import { Controller } from "@hotwired/stimulus";
import { CsrfToken } from "../shared/csrf_token";
import { XmlHttpRequest } from "../shared/xml_http_request";

// Connects to data-controller="resumin--entry-mail-payment"
export default class extends Controller {
  connect() {
    CsrfToken(this);
    XmlHttpRequest(this);
  }

  submit(e) {
    e.preventDefault();

    const form = this.element;
    const formData = new FormData(form);

    fetch("/xhr/payment", {
      method: "POST",
      body: formData,
      headers: {
        ...this.csrfToken(),
        ...this.xmlHttpRequest(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((response) => {
        return this._postSbPaymentPurchaseRequest(response);
      })
      .catch((error) => {
        console.error("Payment error:", error);
      });
  }

  _postSbPaymentPurchaseRequest(json) {
    const form = this.element;
    form.acceptCharset = "SHIFT_JIS";

    const results = json["result"];
    form.appendChild(this._createHiddenInput("order_id", results["order_id"]));
    form.appendChild(
      this._createHiddenInput("sps_hashcode", results["sps_hashcode"])
    );

    form.requestSubmit();
  }

  _createHiddenInput(name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }
}
